import { Helmet } from 'react-helmet-async';
import { Route, Routes } from 'react-router';

import { Breadcrumbs, MainContent, MainNav, MainPanel } from '../../shared';
import {
  AccountListPage,
  AccountPageContainer,
  AllAccountListPage,
  OverageAccountListPage,
  UnpaidAccountListPage,
} from '../containers';

import { DiagnosticUsageDetailsPage } from './DiagnosticUsageDetailsPage';
import { DiagnosticUsageOverviewPage } from './DiagnosticUsageOverviewPage';
import { PlanUsageDetailsPage } from './PlanUsageDetailsPage';
import { PlanUsageOverviewPage } from './PlanUsageOverviewPage';
import { SDKApplicationDetailPage } from './SDKApplicationDetailPage';
import { SDKUsageOverviewPage } from './SDKUsageOverviewPage';

export const AccountsWrapper = () => (
  <MainPanel>
    <MainNav>
      <Breadcrumbs />
    </MainNav>
    <MainContent>
      <Helmet>
        <title>Accounts</title>
      </Helmet>
      <Routes>
        <Route
          index
          element={<AccountListPage displayUnpaidOnly={false} displayWithoutQuery={false} showOverages={false} />}
        />
        <Route path="all" element={<AllAccountListPage />} />
        <Route path="unpaid" element={<UnpaidAccountListPage />} />
        <Route path="overages" element={<OverageAccountListPage />} />
        <Route path=":accountId/plan-usage/details/:metricType" element={<PlanUsageDetailsPage />} />
        <Route path=":accountId/plan-usage" element={<PlanUsageOverviewPage />} />
        <Route path=":accountId/diagnostic-usage/details/:metricType" element={<DiagnosticUsageDetailsPage />} />
        <Route path=":accountId/diagnostic-usage" element={<DiagnosticUsageOverviewPage />} />
        <Route path=":accountId/sdks/:applicationId" element={<SDKApplicationDetailPage />} />
        <Route path=":accountId/sdks" element={<SDKUsageOverviewPage />} />
        <Route path=":accountId" element={<AccountPageContainer />} />
      </Routes>
    </MainContent>
  </MainPanel>
);
